import { fetchSeoContent } from "../Api/index";

export default {
    state: {
        data: {}
    },
    mutations: {
        SET_DATA(state, payload) {
            state.data = payload;
        }
    },

    actions: {
        async getSeo(context) {
            const { data } = await fetchSeoContent();
            context.commit("SET_DATA", data);
        }
    },

    getters: {
        seoData(state) {
            return state;
        }
    }
};
